import api from "./api";
import { logout } from "../utils/openidUtils";
import { Auth } from "aws-amplify";

export const login = async () => {
  const session = await Auth.currentSession();
  const accessToken = session.getAccessToken().getJwtToken();
  const idToken = session.getIdToken().getJwtToken();
  const response = await api.post(
    "/auth/cognito/exchange/",
    { id_token: idToken },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  if (!response?.data?.access || !response?.data?.refresh) {
    const error = new Error("Cognito token exchange failed.");
    error.response = response;
    throw error;
  }
  localStorage.setItem("gw3_user", JSON.stringify(response.data));
  return response.data;
};

export const apiLogout = () => {
  logout();
  localStorage.clear();
};

export const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("gw3_user"));
};
